import * as navigator from "client_legacy/ndaw/navigator";
import { DocumentItemType, ListLocationViewModel } from "client/Api/Documents/SharePoint/common";
import { getExtension } from "client_legacy/Documents/path";
import { getAuthority } from "client_legacy/ndaw/urlHelper";

type AppName = "onenote" | "ms-word" | "ms-excel" | "ms-powerpoint" | "ms-visio";

export interface DocumentForOpening {
	itemType: DocumentItemType;
	name: string;
	location: ListLocationViewModel;
	serverRelativeUrl: string;
}

// Based on SP's editDocumentWithProgID2 & CreateProtocolHandlerUrl in core.js
export function open(document: DocumentForOpening) {
	const appName: AppName = getAppName(document);
	const authority: string = getAuthority(document.location.siteUrl);
	const documentAbsoluteUrl: string = authority + document.serverRelativeUrl;

	if (appName === "onenote") {
		openUrlInLocalApp(appName + ":" + documentAbsoluteUrl);
	} else {
		//https://msdn.microsoft.com/en-us/library/office/dn906146.aspx
		openUrlInLocalApp(appName + ":ofe|u|" + documentAbsoluteUrl);
	}
}

function getAppName(document: { itemType: DocumentItemType; name: string; }): AppName {
	switch (document.itemType) {
		case DocumentItemType.OneNoteNotebook:
			return "onenote";
		case DocumentItemType.Folder:
			throw new Error("Can't open folders");
		case DocumentItemType.File:
			const extension: string = getExtension(document.name);
			switch (extension.toLowerCase()) {
				case ".doc":
				case ".docx":
				case ".dotx":
				case ".docm":
				case ".dotm":
					return "ms-word";
				case ".csv":
				case ".xls":
				case ".xlsb":
				case ".xlsm":
				case ".xlsx":
					return "ms-excel";
				case ".potx":
				case ".pptx":
				case ".ppt":
				case ".pptm":
					return "ms-powerpoint";
				case ".vsd":
				case ".vsdx":
					return "ms-visio";
				case ".one":
					return "onenote";
				default:
					throw new Error(`Extension '${extension}' is not supported for local app`);
			}
		default:
			return unknownDocumentItemType(document.itemType);
	}
}

function unknownDocumentItemType(documentItemType: never): never {
	throw new Error(`Unknown document '${documentItemType}'`);
}

function openUrlInLocalApp(url: string) {
	navigator.navigateTo(encodePath(url));
}

function encodePath(url: string): string {
	return encodeURI(url).replace(/#/g, "%23");
}
